require('./globalPositionInvestmentsContentCC.scss');
const React = require('react');
const {connect} = require('react-redux');
const forEach = require('lodash/collection/forEach');
const PropTypes = require('prop-types');
const { TabbedContentBox } = require('commonsComponents/tabbedContentBox');
// @components
const InvestmentsResume = require('components/contactCenter/globalPositionInvestmentsContentCC/investmentsResume/investmentsResume');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const TruncateText = require('components/commons/truncateText/truncateText');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ helpers
const currencyHelper = require('utilities/currencyHelper');
// @ constants
const {EMPTY_CONCEPT} = require('constants/index');
const {API_ENTERPRISE_NUMBER, API_CENTER} = require('constants/index');

class GlobalPositionInvestmentsContentCC extends React.Component {

    getGeneralDataForTabLabels() {
        const {immBrokerData} = this.props;

        const {quantity: valuesQuantity, balance: [valuesBalance]} = immBrokerData.getIn(['walletSummarization', 'values']).toJS();
        const {quantity: fundsQuantity, balance: [fundsBalance]} = immBrokerData.getIn(['walletSummarization', 'funds']).toJS();
        const {quantity: plansQuantity, balance: [plansBalance]} = immBrokerData.getIn(['walletSummarization', 'plans']).toJS();

        const valuesBalanceObject = currencyHelper.formatAmountObject(valuesBalance);
        const fundsBalanceObject = currencyHelper.formatAmountObject(fundsBalance);
        const plansBalanceObject = currencyHelper.formatAmountObject(plansBalance);

        const valuesAmountFormatted = `${valuesBalanceObject.amount} ${valuesBalanceObject.currencySymbol}`;
        const fundsAmountFormatted = `${fundsBalanceObject.amount} ${fundsBalanceObject.currencySymbol}`;
        const plansAmountFormatted = `${plansBalanceObject.amount} ${plansBalanceObject.currencySymbol}`;

        return {
            values: {
                quantity: valuesQuantity,
                formattedAmount: valuesQuantity ? valuesAmountFormatted : EMPTY_CONCEPT
            },
            funds: {
                quantity: fundsQuantity,
                formattedAmount: fundsQuantity ? fundsAmountFormatted : EMPTY_CONCEPT
            },
            plans: {
                quantity: plansQuantity,
                formattedAmount: plansQuantity ? plansAmountFormatted : EMPTY_CONCEPT
            }
        };
    }

    getValuesContracts(){
        const { immBrokerData } = this.props;
        const walletList = immBrokerData.get('walletList').toJS();
        let walletData = [];

        forEach(walletList, (walletItem) => {
            const fullContractNumber = walletItem.fullContractNumber;
            const plainAmountObject = {
                amount: walletItem.saldo1.importe,
                currency: walletItem.saldo1.divisa
            };
            const value = (
                <OneLineSymbolAmount
                    key={fullContractNumber}
                    amountObject={plainAmountObject}
                    language={getLanguage()}
                    amountObjectFormatted={currencyHelper.formatAmountObject(plainAmountObject, true)}
                />
            );

            walletData.push([fullContractNumber, value]);
        });

        return walletData;
    }

    getProductsList(immBrokerData, list){
        const productsList = immBrokerData.get(list).toJS();
        let data = [];

        forEach(productsList, (item) => {
            const fullContractNumber = API_ENTERPRISE_NUMBER + API_CENTER + item.contrato.producto + item.contrato.numerodecontrato;
            let description = item.descripcion ? item.descripcion.trim() : '-';

            if (description.length > 30) {
                description = (
                    <OKTooltip
                        content={description}
                        target={
                            <span>
                                <TruncateText
                                    str={description}
                                    charLimit={30}
                                    lineAmount={1}
                                />
                            </span>
                        }
                    />
                );
            }

            const plainAmountObject = {
                amount: item.saldo1.importe,
                currency: item.saldo1.divisa
            };
            const value = (
                <OneLineSymbolAmount
                    key={fullContractNumber}
                    amountObject={plainAmountObject}
                    language={getLanguage()}
                    amountObjectFormatted={currencyHelper.formatAmountObject(plainAmountObject, true)}
                />
            );

            data.push([fullContractNumber, description, value]);
        });

        return data;
    }

    render() {
        const {immBrokerData} = this.props;
        const tabDataLabels = this.getGeneralDataForTabLabels();
        const valuesData = this.getValuesContracts();
        const fundsData = this.getProductsList(immBrokerData, 'fundsList');
        const plansData = this.getProductsList(immBrokerData, 'plansList');

        const tabLabels = [
            <FormattedText
                key="stocksTabLabel"
                value="pGInvestments-stocksTabLabel"
                injectedStrings={[tabDataLabels.values.quantity, tabDataLabels.values.formattedAmount]}
            />,
            <FormattedText
                key="fundsTabLabel"
                value="pGInvestments-fundsTabLabel"
                injectedStrings={[tabDataLabels.funds.quantity, tabDataLabels.funds.formattedAmount]}
            />,
            <FormattedText
                key="plansTabLabel"
                value="pGInvestments-plansTabLabel"
                injectedStrings={[tabDataLabels.plans.quantity, tabDataLabels.plans.formattedAmount]}
            />
        ];

        const tabComponents = [
            <InvestmentsResume key="values" columnsInfo={valuesData} seeAllLink="myprofile/broker/general"/>,
            <InvestmentsResume key="funds" columnsInfo={fundsData} seeAllLink="myprofile/broker/funds"/>,
            <InvestmentsResume key="plans" columnsInfo={plansData} seeAllLink="myprofile/broker/plans"/>
        ];

        return (
            <div className="investments-cc-content">
                <TabbedContentBox
                    tabComponents={tabComponents}
                    tabLabels={tabLabels}
                    title=""
                    defaultTabIndex={0}
                />
            </div>
        );
    }
}

GlobalPositionInvestmentsContentCC.propTypes = {
    immBrokerData: PropTypes.object
};

module.exports = connect(state => ({
    immBrokerData: state.brokerWallets
}),null)(GlobalPositionInvestmentsContentCC);
